import React from 'react';
import './landing.css';
import Authadmin from "../Auth/Auth"
import logo from "../../assets/vmou.png";
import { connect } from 'react-redux';

const mainpage = (props) => {
  if (props.token === null){
    localStorage.removeItem('token');}
  return (
    <div className="Appacc">
      <div className="App-mainacc">
        <div className="App-loginacc">
          <span style={{margin:'20px 0 120px 0'}}>For help and Support Contact : 9828137504</span>
          <Authadmin />
        </div> 
        <div className="App-messageacc">
          <div >
            <img className="mt-0" src={logo} alt="VMOU" height={200} width={180}></img>
          </div>
          <div className="App-titleacc mt-2">
            <h2 style={{marginBottom:'0px'}}>Vardhman Mahaveer Open University </h2>
            <h2 style={{marginTop:'0px'}}> Regional Centre Module</h2>
          </div>
          <h2>Important Instructions</h2>
          <ul className='mb-8'>
            <li>All Examiners are to be added with complete details as per the entry form.</li>
            <li>Practical batches will be created as per the batchsize for all registered students in schno order.</li>
            <li>One batch with one batch number is to be assigned to one examiner only.</li>
            <li>Practical Date entry for each batch to be done at the time of assigning the batch to the examiner</li>
            {/* <li>Date received entry is to be done when the batch is received after marks submission from the examiner.(Please check the submit date in the batch list)</li> */}
          </ul>
        </div>   
      </div>
    </div>
  );
}
const mapStateToProps = state => ({token:state.auth.token});

export default connect(mapStateToProps)(mainpage);